import { useState } from "react";
import { IonIcon } from "@ionic/react";
import { expand, contract } from "ionicons/icons";

export function FullscreenButton() {
  const [isFullscreen, setIsFullscreen] = useState(false);

  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      setIsFullscreen(true);
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
        setIsFullscreen(false);
      }
    }
  };

  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <button
        onClick={toggleFullscreen}
        style={{
          padding: "10px 20px",
          fontSize: "1.2rem",
          backgroundColor: "transparent",
          border: "none",
        }}
      >
        <IonIcon
          size="large"
          icon={isFullscreen ? contract : expand}
          style={{ color: "black" }}
        />
      </button>
    </div>
  );
}